'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var OperaIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<path d="M8.97 0c-4.92 0-8.45 3.57-8.45 8.92 0 4.76 3.44 9.08 8.45 9.08 5.06 0 8.52-4.32 8.52-9.08 0-5.39-3.65-8.92-8.52-8.92zM12.1 8.76c0 2.98-0.16 7.22-3.13 7.22v0c-2.93 0-3.05-4.24-3.05-7.21 0-3.49 0.33-6.83 3.05-6.83 2.72 0 3.13 3.39 3.13 6.83z"/>';
    case 'medium':
      return '<path d="M15.939 0c-8.741 0-15.023 6.34-15.023 15.851 0 8.463 6.109 16.149 15.024 16.149 9.002 0 15.144-7.684 15.144-16.149 0-9.586-6.483-15.851-15.146-15.851zM21.511 15.579c-0.002 5.292-0.284 12.828-5.571 12.828v0.001c-5.212 0-5.42-7.54-5.42-12.822 0-6.199 0.58-12.143 5.42-12.143 4.84 0 5.571 6.018 5.571 12.136z"/>';
    case 'large':
      return '<path d="M23.908 0c-13.112 0-22.535 9.511-22.535 23.776 0 12.695 9.164 24.224 22.537 24.224 13.504 0 22.717-11.526 22.717-24.224 0-14.379-9.724-23.776-22.718-23.776zM32.267 23.369c-0.003 7.938-0.426 19.241-8.357 19.241v0.002c-7.818 0-8.13-11.309-8.13-19.233 0-9.299 0.87-18.214 8.13-18.214 7.26 0 8.357 9.027 8.357 18.204z"/>';
    }
  }
});

module.exports = OperaIcon;


/** WEBPACK FOOTER **
 ** ./atoms/icons/Opera.jsx
 **/